import { render, staticRenderFns } from "./treatmentPage.vue?vue&type=template&id=6debf202&scoped=true&"
import script from "./treatmentPage.vue?vue&type=script&lang=ts&"
export * from "./treatmentPage.vue?vue&type=script&lang=ts&"
import style0 from "./treatmentPage.vue?vue&type=style&index=0&id=6debf202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debf202",
  null
  
)

export default component.exports